module.exports = __webpack_public_path__ + "static/media/BNW_Alphabet_O.d29a375a.jpg";